import React from 'react'
import { useSelector } from 'react-redux'
import useInput from '../hooks/input.hook'
import useFilter from '../hooks/filter.hook'

import Input from './UI/Input'
import Filter from './Filter'
import Amount from './UI/Amount'
import CardSelect from './CardSelect'

import * as filterSelectors from '../redux/selectors/filter.selectors'


function UnknowFilter() {
    const { setUnknowsFilter } = useFilter()

    const filter = useSelector(filterSelectors.unknow)

    const id = useInput(filter.id, (value) => setUnknowsFilter({id: value}))
    const amount = { min: filter.amount.min, max: filter.amount.max }

    const filterOption = [
        { title: 'Card', elem: <CardSelect value={filter.card} handler={(values) => setUnknowsFilter({card: values})}/> },
        { title: 'Amount', elem: <Amount handler={(value) => setUnknowsFilter({amount: value})} value={amount}/> }
    ]

    return (
        <>
            <Filter option={filterOption} />
            <Input input={id} placeholder='id' />
        </>
    )
}

export default UnknowFilter